import { Query } from '@apollo/client/react/components';
import * as React from 'react';
import COMPOSER_GROUPS_QUERY from 'chat/queries/ComposerGroupsQuery.gql';
import COMPOSER_ORGS_QUERY from 'chat/queries/ComposerOrgsQuery.gql';
import { ComposerOrgs } from 'chat/queries/__generated__/ComposerOrgs';
import { ComposerGroups } from 'chat/queries/__generated__/ComposerGroups';
import {
  SplitComposer,
  RequiredProps as SplitComposerProps,
  ReduxDispatchProps,
  ReduxStateProps,
} from './ShareSDKSplitComposer';
import { bindActionCreators } from 'redux';
import {
  clearSelection,
  flush,
  loadGroupChats,
  loadGroups,
  loadIndividuals,
  loadOrganizations,
  loadPotentialChatMembers,
  searchGroupChats,
  selectInitialTargets,
} from 'reducers/roleBasedMessagingSearch';
import { connect, Dispatch } from 'react-redux';
import { filterNull } from 'utils/tsUtils';

type Props = SplitComposerProps & ReduxDispatchProps & ReduxStateProps;

function SplitComposerDataContainer(props: Props) {
  return (
    <Query<ComposerOrgs> query={COMPOSER_ORGS_QUERY}>
      {({ data, loading }) => {
        const orgs = data?.me?.organizations;
        const districts =
          orgs && orgs.filter((o) => o.type === 'District' && o.permissions.canSendAnnouncement);

        const schools =
          orgs && orgs.filter((o) => o.type === 'School' && o.permissions.canSendAnnouncement);
        const orgsLoading = loading;

        return (
          <Query<ComposerGroups> query={COMPOSER_GROUPS_QUERY}>
            {({ data, loading }) => {
              const groups = filterNull(data?.me?.classes ?? []);

              return (
                <SplitComposer
                  {...props}
                  organizations={districts}
                  schools={schools}
                  orgsLoading={orgsLoading}
                  groups={groups}
                  groupsLoading={loading}
                />
              );
            }}
          </Query>
        );
      }}
    </Query>
  );
}

const mapStateToProps = (state: any): ReduxStateProps => {
  const { roleBasedMessagingSearch } = state;
  return {
    savedMessage: roleBasedMessagingSearch.message,
    selection: roleBasedMessagingSearch.selection,
    loadingGroupChats: roleBasedMessagingSearch.loadingGroupChats,
    loadingIndividualRecipients: roleBasedMessagingSearch.loadingIndividualRecipients,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>): ReduxDispatchProps => {
  return bindActionCreators(
    {
      onFlush: flush,
      clearSelection,
      onSelectInitialTargets: selectInitialTargets,
      onLoadGroups: loadGroups,
      onLoadOrganizations: loadOrganizations,
      onLoadGroupChats: loadGroupChats,
      onLoadIndividuals: loadIndividuals,
      onLoadPotentialChatMembers: loadPotentialChatMembers,
      onSearchGroupChats: searchGroupChats,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(SplitComposerDataContainer);
